<template>
  <div>
    <h1>{{ msg }}</h1>
    <div id="reportViewer1">loading...</div>
  </div>
</template>

<script>
import "../../assets/ReportViewer/js/telerikReportViewer-16.0.22.119.min.js";
import "../../assets/ReportViewer/js/telerikReportViewer.kendo-16.0.22.119.min.js";

import { mapGetters } from "vuex";
import { config } from "@/config.js";

export default {
  name: "ReportViewer",
  data() {
    return {
      msg: "",
    };
  },
  computed: {
    ...mapGetters(["reporteActivo", "parametrosReporte", "ambiente"]),
  },
  methods: {
    getReportServiceUrl() {
      //return "https://smarter.argenpesos.com.ar:30011/Reports";
      const ambiente =
        this.$store && this.$store.state ? this.$store.state.ambiente : null;
      const ambienteUrl = ambiente && ambiente.url ? ambiente.url : "";

      if (!ambienteUrl) {
        return "Reports";
      }

      if (!this.isProductionAmbiente()) {
        return `${ambienteUrl}Reports`;
      }

      try {
        const parsedUrl = new URL(ambienteUrl);

        if (!parsedUrl.port) {
          return `${ambienteUrl}Reports`;
        }

        const incrementedPort = Number(parsedUrl.port) + 1;

        if (Number.isNaN(incrementedPort)) {
          return `${ambienteUrl}Reports`;
        }

        parsedUrl.port = String(incrementedPort);
        return `${parsedUrl.toString()}Reports`;
      } catch (error) {
        return `${ambienteUrl}Reports`;
      }
    },
    isProductionAmbiente() {
      const ambiente =
        this.$store && this.$store.state ? this.$store.state.ambiente : null;
      const ambienteId = ambiente && ambiente.id ? ambiente.id : "";
      return /producci[oó]n/i.test(ambienteId);
    },
  },
  mounted() {
    this.$nextTick(function () {
      // console.log(this.reporteActivo);

      // console.log(window.location.href);

      var url = new URL(window.location.href);

      var reporte = url.searchParams.get("reporte");

      if (reporte) reporte = url.searchParams.get("reporte").replace(/_/g, " ");
      else reporte = this.reporteActivo;

      console.log("Parametros Reporte " + reporte);
      console.log(this.parametrosReporte[0]);
      alert(this.getReportServiceUrl());
      $("#reportViewer1").telerik_ReportViewer({
        serviceUrl: this.getReportServiceUrl(),
        reportSource: {
          report: reporte,
          parameters: this.parametrosReporte[0],
        },
        viewMode: telerikReportViewer.ViewModes.INTERACTIVE,
        scaleMode: telerikReportViewer.ScaleModes.SPECIFIC,
        scale: 1.0,
        sendEmail: { enabled: false },
        toggleParametersArea: false,
        updateUi: function (e, args) {
          resizeViewer();
        },
        // Resize the viewer when new report is loaded in the viewer
        pageReady: function (e, args) {
          resizeViewer();
        },
      });
    });
  },
};

function resizeViewer() {
  var pageHeight =
      $(".trv-pages-area .trv-page-wrapper").height() +
      $(".trv-nav").outerHeight() +
      2, // Calcolate the report page height
    parametersAreaDom = $(".trv-parameters-area"),
    parametersAreaVisible = !parametersAreaDom.hasClass("k-state-collapsed"), //
    parametersAreaVertical = parametersAreaDom.hasClass("-vertical"),
    viewer = $("#reportViewer1"),
    viewerHeight = viewer.height();

  if (parametersAreaVisible && parametersAreaVertical) {
    pageHeight += 140;
  }

  if (viewerHeight !== pageHeight) {
    viewer.height(pageHeight);
    var documentMapSplitter = $(".trv-document-map-splitter").data(
      "kendoSplitter",
    );
    documentMapSplitter.resize(true);

    var parameterSplitter = $(".trv-parameters-splitter").data("kendoSplitter");
    parameterSplitter.resize(true);
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
body {
  font-family: Verdana, Arial;
  margin: 5px;
}
.viewer {
  height: 600px;
}

.viewer .k-splitter .k-scrollable {
  overflow: hidden;
}
#reportViewer1 {
  position: absolute;
  top: 70px;
  bottom: 10px;
  left: 10px;
  right: 10px;
  /* height: 1000px; */
  overflow: hidden;
  clear: both;
}
</style>
